import { __assign } from "tslib";
import { connect } from 'react-redux';
import { hideGrid, showScreen } from '../actionCreators';
import NavigationGrid from '../components/NavigationGrid';
import { getFrame, getOrientation, getScreenGroups } from '../selectors';
function mapStateToProps(state) {
    return __assign(__assign({ projectName: state.project.config.name, currentScreenID: state.screen.currentScreen && state.screen.currentScreen.id }, getScreenGroups(state)), { frame: getFrame(state), orientation: getOrientation(state) });
}
function mapDispatchToProps(dispatch) {
    return {
        onSelect: function (screenID) {
            dispatch(showScreen(screenID));
        },
        onClose: function () {
            dispatch(hideGrid());
        },
    };
}
export default connect(mapStateToProps, mapDispatchToProps)(NavigationGrid);
